import { useState, useEffect } from 'react';
import { css, cx } from 'linaria';
import { breakpointLargeHandset, breakpointLargeTablet } from 'common/constants';
import { CloseButton } from 'components/close-button/close-button';
import { containerMaxWidth } from 'common/constants';
import { SectionWrapper } from 'components/section-wrapper/section-wrapper';
import { getValueFromCookie } from 'common/utilities';
const sectionWrapper = "skdfh9i";
const flyawayWrapper = "f15pei09";
const flyaway = "f12zkraf";
const closeButtonOverrides = "c1x5gd1x";
export function Flyaway({
  dataCy = 'flyaway',
  title,
  description,
  handleClose,
  show,
  styleOverrides
}) {
  const [flyawayOpen, setFlyawayOpen] = useState(false); // check whether the OptanonAlertBoxClosed cookie has been set
  // if it has, the cookie consent banner has been closed

  const cookie = document.cookie;
  const bannerClosed = !!getValueFromCookie('OptanonAlertBoxClosed', cookie); // If cookie consent banner is open, grab its height so we can
  // determine the position of the flyaway

  const bannerHeight = !bannerClosed ? document.querySelector('#onetrust-banner-sdk')?.offsetHeight + 30 : 50;
  useEffect(() => {
    let timer;
    if (show) timer = setTimeout(() => setFlyawayOpen(true), 700);else setFlyawayOpen(false);
    return () => clearTimeout(timer);
  }, [show]);
  const flyawayClassName = cx(flyawayWrapper, styleOverrides, flyawayOpen && 'show');
  return <SectionWrapper style={{
    bottom: `${bannerHeight}px`
  }} className={sectionWrapper}>
      <div className={flyawayClassName} data-cy={dataCy}>
        <div className={flyaway}>
          <div className="flyaway_title">
            <h5>{title}</h5>
            <CloseButton handleClose={handleClose} dataCy="close-flyaway-button" closeButtonOverrides={closeButtonOverrides} />
          </div>
          {description ? <div className="description">{description}</div> : null}
        </div>
      </div>
    </SectionWrapper>;
}

require("./flyaway.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./flyaway.js");